<h2 mat-dialog-title>Confirm Saved Card</h2>

<mat-dialog-content>
    <app-vgs-collect-cvv-only
        [vgsVaultId]="data.vgsVaultId"
        [vgsEnvironment]="data.vgsEnvironment"
        [vgsVersion]="data.vgsVersion"
        (cvvCaptured)="onCvvCaptured_storeForConfirm($event)">
    </app-vgs-collect-cvv-only>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close [disabled]="submitting">
        Cancel
    </button>
    <button mat-flat-button color="accent" type="button" (click)="onClick_confirm()" [disabled]="submitting">
        {{ submitting ? 'Confirming&hellip;' : 'Confirm' }}
    </button>
</mat-dialog-actions>
